import React, { useState, useCallback, useContext } from 'react';
import i18next from 'i18next';
import { Repeat, RepeatTiny } from '../../StyledComponents/Repeat';
import InputSelect from '../../StyledComponents/InputSelect';
import { ButtonPrimary, ButtonContent } from '../../StyledComponents/Button';
import Modal from '../../StyledComponents/Modal';
import Content from '../../StyledComponents/Content';
import InputLabel from '../../StyledComponents/InputLabel';
import { BranchConnection } from '../../@types/codegen/types';
import { CentralStorageContext } from './State/CentralStorage/CentralStorageContext';

interface BranchModalProps {
  loading: boolean;
  connections?: BranchConnection[];
  onClose: () => void;
}

const BranchModal = ({ loading, connections, onClose }: BranchModalProps) => {
  const { centralStorageId, setCentralStorageId } = useContext(CentralStorageContext);
  const [localValue, setLocalValue] = useState(centralStorageId);

  const onConfirm = useCallback((id: string) => {
    if (id) {
      setCentralStorageId(id);
    }
  }, []);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => setLocalValue(e.currentTarget.value),
    []
  );

  if (!localValue) {
    return null;
  }

  return (
    <Modal title={i18next.t('item.switchBranch')} onClose={onClose}>
      <Repeat>
        <RepeatTiny>
          <Content>
            <p>{i18next.t('item.switchBranchDescription')}</p>
          </Content>
        </RepeatTiny>
        <RepeatTiny>
          <InputLabel>{i18next.t('item.chooseBranch')}</InputLabel>
          <InputSelect
            value={localValue}
            onChange={onChange}
            options={connections?.map((x) => ({
              value: x.id,
              displayName: x.name,
            }))}
            title={i18next.t('item.chooseBranch')}
          />
        </RepeatTiny>
      </Repeat>
      <Repeat>
        <ButtonPrimary
          disabled={loading}
          fullWidth
          onClick={() => onConfirm(localValue)}
          title={i18next.t('item.chooseSelectedBranch') || ''}
        >
          <ButtonContent>{i18next.t('common.choose')}</ButtonContent>
        </ButtonPrimary>
      </Repeat>
    </Modal>
  );
};

export default BranchModal;
